import { AuthUtils } from '@hakimo-ui/hakimo/types';
import { AuthUtilsContext } from '@hakimo-ui/hakimo/util';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  authUtils: AuthUtils;
}

const AuthUtilsProvider = (props: Props) => {
  const { children, authUtils } = props;

  return (
    <AuthUtilsContext.Provider value={authUtils}>
      {children}
    </AuthUtilsContext.Provider>
  );
};

export default AuthUtilsProvider;
